import { render, staticRenderFns } from "./disclosure_hierarchy_item.vue?vue&type=template&id=53352bbc"
import script from "./disclosure_hierarchy_item.vue?vue&type=script&lang=js"
export * from "./disclosure_hierarchy_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports